module.exports = __webpack_public_path__ + "img/Linearicons-Free.2781bf54.svg";